import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardTitle, Col, Row, Table } from 'reactstrap';
import Switch from "react-switch";
import { useNavigate } from 'react-router-dom';
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { DesktopContainer } from '../layouts';
import { api, constants, dateHelpers, filterHelpers, storage } from '../utils';

export default function Transfers() {
   const navigate = useNavigate();
   const ALL_SITES = { value: "", label: "-- Select --" };
   const [filters, setFilters] = useState([
      { filterName: "siteId", value: ALL_SITES }
   ]);

   const [data, setData] = useState({});
   const [doneList, setDone] = useState({});
   const [isNew, setNew] = useState(false);
   const [loaded, setLoaded] = useState(false);
   const [openList, setOpen] = useState({});
   const [printPDF, setPrintPDF] = useState(false);
   const [sites, setSites] = useState([]);

   let savedDevice = JSON.parse(storage.getItem("deviceType"));
   const isMobile = savedDevice.isMobile;
   const handlePrint = nextChecked => { setPrintPDF(nextChecked); }

   useEffect(() => {
      api
         .fetch(`Transfer/GetTransfers`)
         .then(response => {
            if (response.data.success) {
               setData(response.data.model);
               setDone(response.data.xfers.closed);
               setOpen(response.data.xfers.open);
               const siteList = _.concat([ALL_SITES],
                  _.map(response.data.sites, m => ({ value: m.id, label: m.text })));
               return { siteList: siteList };
            }
            else {
               setData({});
               toast.warning(response.data.message);
            }
         }).then(async ({ siteList }) => {
            setSites(siteList);
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setLoaded(true);
         })
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   function createTransfer() {
      if (!data.toSite || data.toSite === "") {
         toast.error('You must select a site');
         return;
      }

      setLoaded(false);
      api
         .post(`Transfer/CreateTransfer`, data)
         .then(response => {
            if (response.data.success) {
               setNew(false);
               setLoaded(true);
               var nav = constants.ENDPOINTS.transfer + "/" + response.data.rtnId;
               navigate(nav);
            }
            else {
               toast.warning(response.data.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
   }

   function deleteTransfer(id, displayId) {
      confirmAlert({
         title: "Confirm Delete",
         message: `Are you sure? This will permanently delete transfer ${displayId}.`,
         buttons: [
            {
               label: "Yes",
               onClick: () => {
                  setLoaded(false);
                  api
                     .post(`Transfer/DeleteTransfer/${id}`)
                     .then((response) => {
                        if (response.data.success) {
                           setData(response.data.model);
                           setDone(response.data.xfers.closed);
                           setOpen(response.data.xfers.open);
                        } else {
                           toast.error(response.data.message);
                        }
                     })
                     .catch((error) => {
                        api.catchHandler(error);
                        toast.error(error);
                     })
                     .finally(() => {
                        setLoaded(true);
                     })
               },
            },
            {
               label: "No",
            },
         ],
      });
   }

   function editTransfer(id) {
      var nav = constants.ENDPOINTS.transfer + "/" + id;
      navigate(nav);
   }

   function onChange(field, value) {
      let changes = Object.assign({}, data);
      changes[field] = value;
      setData(changes);
   }

   function onSiteChange(newFilterValue) {
      const site = _.find(sites, x => x.value === newFilterValue.value);
      let newFilters = filterHelpers.getFilters(filters, ({ filterName: "siteId", value: site }));
      setFilters(newFilters);
      onChange("toSite", newFilterValue.value);
   }

   function printLabels(id) {
      confirmAlert({
         title: "Confirm Label Print Request",
         message: `Are you sure you want to reprint these partial transfer labels? Doing so will cause any existing labels to become invalid.`,
         buttons: [
            {
               label: "Yes",
               onClick: () => {
                  var url = `Transfer/PrintTransferLabels/${id}/${printPDF}`
                  var displayId = ("000000" + id).slice(-6);
                  setLoaded(false);
                  api.post(`Transfer/TransferLabelsWillPrint/${id}`).then((r) => {
                     if (r && r.data && r.data.success) {
                        if (printPDF) {
                           api
                              .postDownloadBinary(
                                 url,  // api endpoint
                                 {}, // payload (if any)
                                 constants.MIME_TYPES.pdf,
                                 `TR-${displayId} Labels ${dateHelpers.getDateStringForReportName()}.pdf` // filename
                              )
                              .then((res) => {
                                 if (res?.data === false) {
                                    toast.error(res.message);
                                 }
                              })
                              .catch((error) => {
                                 api.catchHandler(error);
                                 toast.error(error);
                              })
                              .finally(() => { setLoaded(true); })
                        }
                        else {
                           api
                              .post(url)
                              .then((response) => {
                                 if (response.data.success) {
                                    toast.success("Inventory transfer labels were reprinted");
                                 } else {
                                    toast.warning(response.data.message);
                                 }
                              })
                              .catch((error) => { api.catchHandler(error); })
                              .finally(() => { setLoaded(true); })
                        }
                     }
                     else if (r && r.data && r.data.message) {
                        toast.error(r.data.message);
                     }
                  }).catch((error) => {
                        api.catchHandler(error);
                        toast.error(error);
                  }).finally(() => { setLoaded(true); })
               },
            },
            {
               label: "No",
            },
         ],
      });
   }

   function reprint(id) {
      var url = `Transfer/PrintTransfer/${id}/${printPDF}`
      setLoaded(false);
      if (printPDF) {
         var displayId = ("000000" + id).slice(-6);
         api
            .postDownloadBinary(
               url,
               {},
               constants.MIME_TYPES.pdf,
               `TR-${displayId}_${dateHelpers.getDateStringForReportName()}.pdf`
            )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
            })
            .finally(() => { setLoaded(true); })
      }
      else {
         api
            .post(url)
            .then(response => {
               if (response.data.success) {
                  toast.success("Inventory transfer was reprinted");
               }
               else {
                  toast.error(response.data.message);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
            })
            .finally(() => { setLoaded(true); })
      }
   }

   return (
      <>
         <DesktopContainer screenName="Transfers">
            <ServiceThreadSpinner on={!loaded}>
               {loaded && data && isNew ?
                  <div>
                     <Table borderless size="sm">
                        <tbody>
                           <tr>
                              <td className="data-cell my-0 py-0">
                                 <label className="h6 fw-bold mx-1 my-0">Transfer To:</label>
                              </td>
                           </tr>
                           <tr>
                              <td className="data-cell my-0 py-0">
                                 <FilterSelect
                                    filterName="siteId"
                                    options={sites}
                                    value={filterHelpers.getValue(filters, "siteId")}
                                    onChangeCallback={e => onSiteChange(e)}
                                 />
                              </td>
                           </tr>
                           <tr><td className="data-cell m-0 p-0 lineheight8">&nbsp;</td></tr>
                           <tr>
                              <td className="data-cell my-0 py-0">
                                 <Button
                                    title="save"
                                    className="shredButton w-100 btn-md my-0"
                                    onClick={() => { createTransfer(); }}>
                                    OK
                                 </Button>
                              </td>
                           </tr>
                           <tr><td className="data-cell m-0 p-0 lineheight8">&nbsp;</td></tr>
                           <tr>
                              <td className="data-cell my-0 py-0">
                                 <Button
                                    title="save"
                                    className="btn w-100 btn-md my-0"
                                    onClick={() => { setNew(false); }}>
                                    Cancel
                                 </Button>
                              </td>
                           </tr>
                        </tbody>
                     </Table>
                  </div>
                  : null
               }
               <br />
               {loaded && data && !isNew ?
                  <div>
                     <div>
                        <Row className="justify-content-center">
                           <Col xs="12">
                              <Button
                                 title="new transfer"
                                 className="shredButton w-100 btn-md my-3"
                                 onClick={() => { setNew(true); }}>
                                 Create New Transfer
                              </Button>
                           </Col>
                        </Row>
                     </div>
                     <br />
                     <Row><Col><hr className="my-0" /></Col></Row>
                     <Row className="align-items-center my-1">
                        <Col className="h6 fw-bold" xs={12}>
                           Open Transfers
                        </Col>
                     </Row>
                     {_.map(openList, (item, index) => {
                        return (
                           <div details={item} key={index} >
                              <Card className="py-0">
                                 <CardBody className={(index % 2 === 0) ? "mobileBlueBg py-1 px-2" : "mobileBlueBgAlt py-1 px-2"}>
                                    <CardTitle className={(index % 2 === 0) ? "mobileBlueBg py-1 px-2" : "mobileBlueBgAlt py-1 px-2"}>
                                       {item.name}
                                    </CardTitle>
                                    {item.id > 0 ?
                                       <Row className="justify-content-center">
                                          <Col xs="6">
                                             <Button children="OPEN"
                                                className="shredButton w-100 btn-sm"
                                                onClick={() => { editTransfer(item.id); }} />
                                          </Col>
                                          <Col xs="6">
                                             <Button children="DELETE"
                                                className="btn w-100 btn-sm"
                                                onClick={() => { deleteTransfer(item.id, item.name); }} />
                                          </Col>
                                       </Row>
                                       : null
                                    }
                                 </CardBody>
                              </Card>
                           </div>
                        )
                     })}

                     <br />
                     <Row><Col><hr className="my-0" /></Col></Row>
                     <Row className="align-items-center my-1">
                        <Col className="h6 fw-bold" xs="12">
                           Recently Completed Transfers
                           {doneList && doneList.length > 0 && doneList[0].id > 0 && !isMobile ? /* This should only show when on a large device */
                              <label>
                                 <span className="my-1">&nbsp; &nbsp; &nbsp; &nbsp; {printPDF ? "Download as PDF" : "Print to printer"}  </span>
                                 <Switch
                                    onChange={handlePrint}
                                    checked={printPDF}
                                    className="react-switch"
                                 />
                              </label>
                              : null
                           }
                        </Col>
                     </Row>
                     {_.map(doneList, (itm, idx) => {
                        return (
                           <div details={itm} key={idx} >
                              <Card className="py-0">
                                 <CardBody className={(idx % 2 === 0) ? "mobileBlueBg py-1 px-2" : "mobileBlueBgAlt py-1 px-2"}>
                                    <CardTitle className={(idx % 2 === 0) ? "mobileBlueBg py-1 px-2" : "mobileBlueBgAlt py-1 px-2"}>
                                       {itm.name}
                                    </CardTitle>
                                    {itm.id > 0 ?
                                       <Row className="justify-content-center">
                                          <Col xs="4">
                                             <Button children="VIEW"
                                                className="shredButton w-100 btn-sm"
                                                onClick={() => { editTransfer(itm.id); }} />
                                          </Col>
                                          <Col xs="4">
                                             <Button children="Reprint"
                                                className="btn w-100 btn-sm"
                                                onClick={() => { reprint(itm.id); }} />
                                          </Col>
                                          <Col xs="4">
                                             <Button children="Print Labels"
                                                className="btn w-100 btn-sm"
                                                onClick={() => { printLabels(itm.id); }} />
                                          </Col>
                                       </Row>
                                       : null
                                    }
                                 </CardBody>
                              </Card>
                           </div>
                        )
                     })}
                  </div>
                  : null
               }
            </ServiceThreadSpinner>
         </DesktopContainer >
      </>
   );
}
